/**
 * Initializes media tabs functionality.
 */
document.querySelectorAll( '.b-media-tabs-onnetwork' ).forEach( ( block ) => {

	/**
	 * Tab buttons within the block.
	 * @type {NodeListOf<Element>}
	 */
	const tabButtons = block.querySelectorAll( '.b-media-tabs-onnetwork__button' );
	const tabWatch = block.querySelector( '.b-media-tabs-onnetwork__tab--video .js-float-tab' );
	const toggleButtons = block.querySelectorAll( '.js-media-tab-trigger' );

	// Check if the screen width is between $sm and $xxl
	const mediaQuery = window.matchMedia( '(min-width: 576px) and (max-width: 1312px)' );

	toggleButtons.forEach( toggleButton => {

		toggleButton.addEventListener( 'click', () => {

			block.classList.toggle( 'b-media-tabs-onnetwork--hidden' );

		} );

	} );

	tabButtons.forEach( button => {

		/**
		 * Handles click event on tab button.
		 */
		button.addEventListener( 'click', () => {

			/**
			 * Selected tab identifier.
			 * @type {string}
			 */
			const selectedTab = button.dataset.tab;

			block.classList.remove( 'b-media-tabs-onnetwork--active-audio', 'b-media-tabs-onnetwork--active-video' );
			block.classList.add( `b-media-tabs-onnetwork--active-${selectedTab}` );

			tabButtons.forEach( btn => {

				btn.classList.remove( 'b-media-tabs-onnetwork__button--active' );

			} );

			button.classList.add( 'b-media-tabs-onnetwork__button--active' );

			const activePlayer = block.querySelector( '.onnetwork-player' );
			if ( typeof window.ONTVsendCommand === 'function' && activePlayer ) {

				const iid = activePlayer.dataset.iid;
				window.ONTVsendCommand( 'pause', iid );

			}

			if ( selectedTab === 'video' ) {

				/**
				 * video tab element.
				 * @type {Element}
				 */
				const watchTab = block.querySelector( '.b-media-tabs-onnetwork__tab--video' );

				/**
				 * Height of the watch tab.
				 * @type {number}
				 */
				const watchTabHeight = watchTab.offsetHeight;
				block.dataset.height = watchTabHeight;

			}

		} );

	} );

	/**
	 * Sets the height of the block based on the data-height attribute.
	 */
	const setBlockHeight = () => {

		if ( block.dataset.height ) {

			block.style.height = `${block.dataset.height}px`;

		}

	};

	let visibleTimeout;

	/**
	 * Observer to monitor the block's position in the viewport.
	 * @type {IntersectionObserver}
	 */
	const observer = new IntersectionObserver( entries => {

		entries.forEach( entry => {

			if ( entry.boundingClientRect.bottom < 0 ) {

				block.classList.add( 'b-media-tabs-onnetwork--float' );
				tabWatch.classList.add( 'b-media-tabs-onnetwork__tab-holder--float' );
				setBlockHeight();

				clearTimeout( visibleTimeout );
				visibleTimeout = setTimeout( () => {

					tabWatch.classList.add( 'b-media-tabs-onnetwork__tab-holder--float-visible' );

				}, 100 );

			} else {

				block.classList.remove( 'b-media-tabs-onnetwork--float' );
				tabWatch.classList.remove( 'b-media-tabs-onnetwork__tab-holder--float' );
				tabWatch.classList.remove( 'b-media-tabs-onnetwork__tab-holder--float-visible' );
				block.style.height = '';
				clearTimeout( visibleTimeout );

			}

		} );

	} );
	if ( !mediaQuery.matches ) {

		observer.observe( block );

	}


	block.querySelectorAll( '[id^="onnetwork-player-"]' ).forEach( ( container ) => {

		const iid = container.dataset.iid;
		const sid = container.dataset.sid;
		const autoplay = container.dataset.autoplay;

		let playerLoaded = false;
		const comQueue = [];



		/**
		 * Handles media information received through an event object and processes commands.
		 *
		 * @param {Object} e - The event object that contains the media information.
		 * @return {void} Does not return a value.
		 */
		function receiveMediaInfo( e ) {

			try {

				if ( !e.data.indexOf || ( e.data.indexOf( "onntv://" ) !== 0 ) ) {

					return;

				}
				let com = {};
				try {

					com = JSON.parse( e.data.substr( 8 ) );

				} catch ( err ) {

					com = {};

				}

				switch ( com.comm ) {

				case "playerLoaded":
					playerLoaded = true;
					break;
				case "volumeset":
				case "moviestarted":
				case "moviecompleted":
				case "moviepaused":
				case "movieresumed":
					break;

				}

			} catch ( err ) {

			}

		}

		window.addEventListener( 'message', receiveMediaInfo );

		if ( !container ) {

			return;

		}

		const validSid = encodeURIComponent( sid || '' );
		const validIid = encodeURIComponent( iid || '' );
		const validAutoplay = encodeURIComponent( autoplay || 0 );

		const newPlayer = document.createElement( "script" );
		newPlayer.src = `https://video.onnetwork.tv/embed.php?onnwid=${validSid}&onnvid=${validIid}&ap=${validAutoplay}&iid=${validIid}`;
		newPlayer.async = true;
		container.appendChild( newPlayer );


		/**
		 * Sends all queued commands in `comQueue` to the currently loaded player if available.
		 * Each command is popped from the queue and dispatched to all frames on the page
		 * via the `postMessage` method.
		 *
		 * @return {void} This method does not return a value.
		 */
		function sendQueue() {

			if ( playerLoaded ) {

				while ( comQueue.length > 0 ) {

					const comtxt = comQueue.pop();
					for ( let i = 0; i < window.frames.length; i++ ) {

						window.frames[i].postMessage( `onntv://${  comtxt}`, "*" );

					}

				}

			}

		}
		setInterval( sendQueue, 1000 );

		/**
		 * Sends a command to the ONTV system.
		 *
		 * This function is part of the `window` object and is used to send specified commands
		 * to the ONTV system for execution. The exact commands and their parameters should
		 * adhere to the ONTV system's API specifications.
		 *
		 * @param {string} command - The command to be sent to the ONTV system.
		 * @param {string} targetId
		 * @param {string} subject
		 *
		 * @return {void}
		 */
		window.ONTVsendCommand = function ONTVsendCommand( command, targetId, subject ) {

			const com = {
				sender: "onntv",
				sscript: "webpage",
				iid: targetId || iid,
				comm: command
			};
			if ( typeof subject !== 'undefined' ) {

				com.subject = subject;

			}
			comQueue.push( JSON.stringify( com ) );

		};

	} );

} );
